import { useState } from 'react';
import SmallModal from '../../global/SmallModal';
import { InitiatePayoutResponse, StripeSummary } from '../../../types/stripe';
import PayoutForm from './PayoutForm';
import PayoutSuccess from './PayoutSuccess';

interface Props {
  summary: StripeSummary;
  open: boolean;
  onClose: () => void;
}

function InstantPayoutModal({ summary, open, onClose }: Props) {
  const [successPayoutData, setSuccessPayoutData] =
    useState<InitiatePayoutResponse | null>(null);

  const onSuccess = (data: InitiatePayoutResponse) => {
    setSuccessPayoutData(data);
  };

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      title="Instant Payout"
      width={480}>
      {successPayoutData && <PayoutSuccess data={successPayoutData} />}
      {!successPayoutData && (
        <PayoutForm summary={summary} onSuccess={onSuccess} />
      )}
    </SmallModal>
  );
}

export default InstantPayoutModal;
